import { ArrowLeftIcon } from '@heroicons/react/16/solid';
import clsx from 'clsx';
import { BookmarksMenu } from '../bookmarks-menu';
import { ChangeLanguageButton } from '../change-language-button';
import { IconButton } from '../ui/icon-button';
import { ProgressBar } from '../ui/progress-bar';

export function ProgressLayout({
  prev,
  progress,
  nextLabel,
  showMenu = true,
  className,
  headerClassName,
  children,
}) {
  // const extendedSteps = useMemo(() => {
  //   const list = [...steps];

  //   const expand = (baseKey, questions, prefix) => {
  //     const idx = list.findIndex((s) => s.key === baseKey);
  //     if (idx !== -1 && Array.isArray(questions)) {
  //       const questionSteps = questions.map((q) => ({ key: `${prefix}-${q.id}` }));
  //       list.splice(idx + 1, 0, ...questionSteps);
  //     }
  //   };

  //   expand('health-questions', healthQuestions, 'health-questions');
  //   expand('preference-questions', preferenceQuestions, 'preference-questions');

  //   return list;
  // }, []);

  return (
    <div className={clsx('w-full h-[100dvh] relative overflow-hidden bg-brand flex', className)}>
      <div className="relative w-full sm:w-[640px] max-h-[100dvh] flex-shrink-0 flex flex-col">
        <div
          className={clsx(
            'pb-5 max-h-[100dvh] flex-1 flex flex-col max-w-full overflow-x-hidden overflow-y-auto',
            {
              'max-h-[calc(100dvh-3.125rem)]': showMenu,
            },
          )}
        >
          <header className="pt-2.5 px-5 mb-5 bg-white">
            <div
              className={clsx(
                'flex flex-row justify-between items-center gap-5 lg:gap-12.5 pb-2.5 border-b border-solid',
                headerClassName,
              )}
            >
              <IconButton
                to={`../${prev?.path}`}
                viewTransition
                variant="white"
                size="md"
                aria-label={prev?.label}
                className={clsx(prev || 'invisible')}
              >
                <ArrowLeftIcon className="size-5" />
              </IconButton>

              <ProgressBar progress={progress * 100} />

              <ChangeLanguageButton size="md" />
            </div>
          </header>

          <main className="px-5 flex-grow flex flex-col">
            <section>{children}</section>
          </main>
        </div>
        {showMenu && <BookmarksMenu nextLabel={nextLabel} />}
      </div>

      <div className="relative flex-[1.25] hidden sm:block before:absolute before:inset-0 before:bg-white/80 brand-background"></div>
    </div>
  );
}
